export enum Alignment {
  Center = 'center',
  Left = 'left',
  Right = 'right'
}

// for builder.io mapping
export const textAlignmentProps = {
  name: 'textAlignment',
  type: 'string',
  enum: ['left', 'center', 'right'],
  defaultValue: 'left'
}

const getAlignmentClass = (textAlignment: Alignment) => {
  if (textAlignment === Alignment.Right) {
    return 'text-right'
  }
  if (textAlignment === Alignment.Center) {
    return 'text-center'
  }
  return 'text-left'
}

export default getAlignmentClass
